import { SentimentWordConfig } from './types';

export const koSentimentWordConfig: SentimentWordConfig = {
    positiveWords: new Set([
        '좋다',
        '최고',
        '완료',
        '완성',
        '성공',
        '안전',
        '안정',
        '개선',
        '해결',
        '준비',
        '성장',
        '행복',
        '강함',
        '우수',
        '훌륭',
        '유용',
        '명확',
        '안심',
        '건강',
        '지원',
        '승리',
        '회복',
        '순조',
        '희망',
        '긍정',
        '진전',
        '향상',
        '기쁨',
        '보람',
        '든든',
        '기대',
        '만족',
        '명랑',
        '믿음',
        '반가움',
        '보호',
        '빛남',
        '사랑',
        '성취',
        '수월',
        '신뢰',
        '안락',
        '안정감',
        '앞으로',
        '열정',
        '완벽',
        '원활',
        '인정',
        '자랑',
        '정돈',
        '좋아',
        '즐거움',
        '튼튼',
        '희열',
        '회복력',
        '효과적',
        '확실',
        '활기',
        '환영',
        '희망적',
        '가벼움',
        '가능',
        '감동',
        '건실',
        '고마움',
        '기분좋음',
        '낙관',
        '도움',
        '든든함',
        '매끄러움',
        '미소',
        '반짝임',
        '밝음',
        '보람됨',
        '부드러움',
        '성장세',
        '소중함',
        '신남',
        '안도',
        '안전함',
        '여유',
        '완성도',
        '유익',
        '이로움',
        '자신감',
        '정상',
        '좋은편',
        '쾌적',
        '탄탄',
        '평온',
        '풍요',
        '행운',
        '화사',
        '활발',
        '효율',
        '확신',
        '환한',
        '회생',
        '희소식',
        '희망참',
    ]),
    negativeWords: new Set([
        '나쁘다',
        '최악',
        '실패',
        '고장',
        '문제',
        '위험',
        '불안',
        '지연',
        '느림',
        '긴급',
        '리스크',
        '버그',
        '오류',
        '혼란',
        '슬픔',
        '위협',
        '싫다',
        '위기',
        '거절',
        '회귀',
        '정체',
        '약함',
        '걱정',
        '불량',
        '어려움',
        '고통',
        '불안정',
        '악화',
        '취약',
        '막힘',
        '고통스러움',
        '공포',
        '골치',
        '나쁨',
        '난감',
        '답답',
        '당황',
        '문제점',
        '불편',
        '불쾌',
        '불만',
        '불신',
        '비상',
        '상처',
        '실망',
        '악몽',
        '압박',
        '위태',
        '위험함',
        '짜증',
        '충돌',
        '취약함',
        '큰일',
        '탈락',
        '통증',
        '파손',
        '피곤',
        '혼잡',
        '혼선',
        '후퇴',
        '막막',
        '망가짐',
        '중단',
        '긴장',
        '부정',
        '괴로움',
        '거슬림',
        '걱정됨',
        '고립',
        '고생',
        '끔찍',
        '난처',
        '답답함',
        '두려움',
        '뒤처짐',
        '망침',
        '못마땅',
        '무너짐',
        '불편함',
        '불행',
        '비관',
        '상실',
        '상처남',
        '소란',
        '실수',
        '악화됨',
        '어수선',
        '염려',
        '위기감',
        '위협적',
        '짜증남',
        '충격',
        '침체',
        '퇴보',
        '혼돈',
        '화남',
        '훼손',
        '지침',
        '치명적',
        '위축',
    ]),
};
